import { ExternalLink } from 'lucide-react';
import { Citation } from '../../services/chatbot.service';
import { buildSourceLine, safeExternalUrl } from '../../utils/citationFormat';

interface FuentesCitadasProps {
  citations: Citation[];
  onOpen: (citation: Citation) => void;
}

/**
 * «Fuentes citadas» como nota al pie (M-8, maqueta 2026-10-14-modos-respuesta, aprobada): línea fina arriba, letra
 * menor y tono suave; número, «Institución - Tipo N° número (fecha)» y «Fuente ↗» a la derecha si hay enlace.
 * El nombre abre el panel de la fuente, como el número de la cita. Reemplaza el pie «N fuentes» (decisión del 11-07).
 */
export default function FuentesCitadas({ citations, onOpen }: FuentesCitadasProps) {
  if (citations.length === 0) return null;
  return (
    <section aria-label="Fuentes citadas" className="mt-[22px] pt-2.5 border-t border-slate-100">
      <p className="text-[11.5px] text-slate-500 mb-1">Fuentes citadas</p>
      <ol className="m-0 p-0 list-none">
        {citations.map((c, i) => {
          const sourceUrl = safeExternalUrl(c.source_url);
          return (
          <li key={c.document_id} className="flex items-baseline gap-2.5 text-[12.5px] leading-[22px] text-slate-500">
            <span className="w-3 flex-none text-right text-slate-500 tabular-nums">{i + 1}</span>
            <button
              type="button"
              onClick={() => onOpen(c)}
              title={c.titulo || undefined}
              className="flex-1 min-w-0 truncate text-left hover:text-slate-700 focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 rounded"
            >
              {buildSourceLine(c)}
            </button>
            {sourceUrl && (
              <a
                href={sourceUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-none inline-flex items-center gap-1 text-xs text-slate-500 no-underline hover:text-slate-700 focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 rounded"
              >
                Fuente
                <ExternalLink className="w-3 h-3" strokeWidth={1.8} aria-hidden="true" />
              </a>
            )}
          </li>
          );
        })}
      </ol>
    </section>
  );
}
